/*
 * Ploufe — subtiele beweging.
 * - Scroll reveal: secties faden in en schuiven licht omhoog zodra ze in beeld komen.
 * - Zachte parallax op grote hero-/sfeerbeelden.
 * Respecteert prefers-reduced-motion volledig (dan doet dit script niets).
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* ---- Scroll reveal ----
       Animatie mag alleen iets toevoegen, nooit iets verbergen: de klasse
       .ploufe-motion (die de CSS het verbergen laat doen) komt pas op <html>
       als de observer draait, en alles wat al in beeld staat krijgt meteen
       .ploufe-in. Geen threshold op een percentage van de sectie: een lange
       sectie (een productgrid van 6000px) haalt 15% zichtbaar nooit en bleef
       dan onzichtbaar. Nu telt alleen of de bovenrand in beeld komt. */
    if (!('IntersectionObserver' in window)) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ploufe-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach(function (section, index) {
      if (index === 0 || section.getBoundingClientRect().top < viewportHeight) {
        section.classList.add('ploufe-in');
      } else {
        io.observe(section);
      }
    });

    document.documentElement.classList.add('ploufe-motion');

    // Vangnet: wat na het laden boven de onderrand staat, komt hoe dan ook in beeld.
    window.addEventListener('load', function () {
      window.setTimeout(function () {
        sections.forEach(function (section) {
          if (section.getBoundingClientRect().top < (window.innerHeight || viewportHeight)) {
            section.classList.add('ploufe-in');
          }
        });
      }, 1500);
    });

    /* ---- Gestaggerde reveal binnen groepen (categorieën, producten, foto's, lagen, stalen) ----
       Elk kind-element van een [data-ploufe-stagger]-container krijgt een eigen
       kleine vertraging, zodat ze één voor één (1, dan 2, dan 3, ...) invloeien
       zodra de groep in beeld scrolt. ---- */
    var staggerGroups = document.querySelectorAll('[data-ploufe-stagger]');

    if ('IntersectionObserver' in window && staggerGroups.length) {
      var staggerIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('ploufe-stagger-in');
              staggerIo.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -10% 0px' }
      );

      staggerGroups.forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          child.style.setProperty('--ploufe-stagger-i', i);
        });
        staggerIo.observe(group);
      });
    } else {
      staggerGroups.forEach(function (group) {
        group.classList.add('ploufe-stagger-in');
      });
    }

    /* ---- Parallax op grote beelden ---- */
    var targets = [];
    document.querySelectorAll('.ploufe-hero--full .ploufe-hero__media img, .ploufe-showcase__media img, .ploufe-story__media img, .ploufe-mat__media img, .ploufe-mat__media video').forEach(function (el) {
      el.classList.add('ploufe-parallax');
      targets.push(el);
    });

    if (!targets.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;

      for (var i = 0; i < targets.length; i++) {
        var el = targets[i];
        var host = el.closest('.shopify-section') || el.parentElement;
        var rect = host.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) continue;

        // -1 (net onderaan) .. 1 (net bovenaan)
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        el.style.setProperty('--ploufe-px', (progress * -22).toFixed(1) + 'px');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });
})();
